import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { distinctUntilChanged } from "rxjs/operators";

import { DataService } from "./dataservices/data.service";
import { SharedDataService } from "./shared-data.service";

export const SHORTCUT_CATEGORIES = "c";

@Injectable({
  providedIn: "root",
})
export class ShortcutCategoryService {
  constructor(private readonly sharedData: SharedDataService, private readonly dataService: DataService) {}

  loadShortcutCategory(options = { reloadFromApi: false }, callback?: () => void): void {
    const shortcutCategories = this.sharedData.storage.retrieve(SHORTCUT_CATEGORIES);

    if (Array.isArray(shortcutCategories) && shortcutCategories.length > 1 && !options.reloadFromApi) {
      return;
    }

    this.dataService.get({ url: "v1/user/shortcut-category", isLoader: false }).subscribe({
      next: (response: any) => {
        this.sharedData.storage.store(SHORTCUT_CATEGORIES, response.result);
      },
      error: (err) => {},
      complete: () => {
        if (callback) {
          callback();
        }
      },
    });
  }

  trackChangesToShortcutCategory(): Observable<any> {
    return this.sharedData.storage
      .observe(SHORTCUT_CATEGORIES)
      .pipe(distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)));
  }
}
